export class MaskSprite extends PIXI.Sprite {

    private _maskTexture: PIXI.Texture;

    constructor(texture?: PIXI.Texture, maskTexture?: PIXI.Texture) {
        super(texture);

        this._maskTexture = maskTexture;
        this.pluginName = 'maskSprite';
    }

    public get maskTexture(): PIXI.Texture {
        return this._maskTexture;
    }

    public set maskTexture(value: PIXI.Texture) {
        this._maskTexture = value;
    }
}


// WEBPACK FOOTER //
// ./@fantasmagames/core/src/sprites/MaskSprite.ts